import InviraRolesCreate from './InviraRolesCreate.vue'
export {InviraRolesCreate}
export default InviraRolesCreate

